

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_3_madefor";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_3_madefor__root","madefor":"wds_1_220_3_madefor__madefor"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wix-font-stack":"--wix-font-stack","wix-font-weight-regular":"--wix-font-weight-regular","wix-font-weight-medium":"--wix-font-weight-medium","wix-font-weight-bold":"--wix-font-weight-bold","wix-font-weight-xbold":"--wix-font-weight-xbold"}; 




